import { Box, Button } from "@mui/material";
import React from "react";
import config from "../Config";

function executeCommand() {
  const commandBox: HTMLTextAreaElement = document.getElementById(
    "cmd"
  ) as HTMLTextAreaElement;
  fetch(`${config.hegbotUrl}/command`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ text: commandBox.value }),
  });
  commandBox.value = "";
}

export default function Commands() {
  return (
    <Box>
      <input id="cmd" type="text" data-testid="cmd-input" size={50} />
      <Button
        type="button"
        onClick={() => executeCommand()}
        variant="outlined"
        size="medium"
        sx={{
          color: "white",
          border: "1px solid black",
          borderRadius: "12px",
          backgroundColor: "rgb(74, 74, 74)",
          height: "4em",
          textTransform: "none",
          margin: "2px",
          zIndex: 0,
          ml: "25px",
          "&:hover": {
            border: `2px solid white`,
            backgroundColor: "rgb(74, 74, 74)",
          },
        }}
      >
        EXECUTE
      </Button>
    </Box>
  );
}
